import { LanguageOutputWithStatus } from './language-output-with-status.model';


export class LanguageSelectByIdOutput implements ILanguageSelectByIdOutput {
    status!: number;
    message!: string;
    data!: LanguageOutputWithStatus;

    constructor(data?: ILanguageSelectByIdOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
            this.data = _data["data"] ? LanguageOutputWithStatus.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): LanguageSelectByIdOutput {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageSelectByIdOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ILanguageSelectByIdOutput {
    status: number;
    message: string;
    data: LanguageOutputWithStatus;
}

